module.exports = __webpack_public_path__ + "static/media/46.4e6668a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/46.png
// module id = 470
// module chunks = 0